function Mma({ dimensions, col = '#000' }) {
  const baseXml = `
    <svg width=${dimensions || '24'} height=${dimensions || '24'} viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M39.6 5L23.2 18.4L20.78 16.32L27.98 12.16L18.82 3L16 5.82L21.48 11.3L10 17.92L7.62 26.5L12.54 35L16 33L11.94 25.96L12.64 23.36L19 27L20 45H24L25 25L42 7.8L39.6 5Z" fill=${`"${col}"`}/>
      <path d="M10 15C12.2091 15 14 13.2091 14 11C14 8.79086 12.2091 7 10 7C7.79086 7 6 8.79086 6 11C6 13.2091 7.79086 15 10 15Z" fill=${`"${col}"`}/>
    </svg>
  `;

  return baseXml;
}

export default Mma;
